import {
  CloudDownload,
  CloudUpload,
} from '@mui/icons-material';
import { Stack } from '@mui/material';
import ToggleButtonCreator from 'Global/Components/CommonComponents/ToggleButtonCreator/ToggleButtonCreator';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { useAtom } from 'jotai';
import React from 'react';
import { modeSwitcherAtom } from '../Shared/mode.switcher';

export default function ModeSwitcher() {
  const upload_label = FindLangKey(
    'genral-public-label-personal'
  );
  const download_label = FindLangKey(
    'genral-public-label-send-from-center'
  );

  const icons = [
    {
      value: 'personal',
      text: upload_label,
    },
    {
      value: 'sendbycenter',
      text: download_label,
    },
  ];

  const [mode, setMode] = useAtom(modeSwitcherAtom);

  console.log('mode=>', {
    upload_label,
    download_label,
  });

  return (
    <>
      <Stack>
        <ToggleButtonCreator
          iconArray={icons}
          onChange={(val) => {
            setMode(val);
          }}
          defaultValue={'personal'}
        />
      </Stack>
    </>
  );
}
